var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deviceType !== "pc"
    ? _c("div", { staticClass: "add_main_screen" }, [
        _c("div", { staticClass: "txt" }, [
          _vm._v(_vm._s(_vm.$t("m.link_add_mainpage")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                return _vm.goAddNotePage()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("m.click_me_to_add")))]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-161b55ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-161b55ed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addscreen.vue
// module id = null
// module chunks = 